function usCurrency(price, notation) {
    const priceFormatted = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        notation,
    }).format(price);

    return price > 0 ? `${priceFormatted} USD` : priceFormatted;
}

function mexCurrency(price) {
    const priceFormatted = new Intl.NumberFormat('es-MX', {
        style: 'decimal',
        minimumFractionDigits: 2,
    }).format(price);

    return `MEX$${priceFormatted}`;
}

// eslint-disable-next-line import/prefer-default-export
export function formatPrice(state, price, notation) {
    // eslint-disable-next-line prefer-destructuring
    let locale = state.options.locale;

    let priceFormatted = price;

    locale = (locale ?? '').replace('-', '_').toLowerCase();

    if (locale === 'en_us' || locale === 'en_ca') {
        priceFormatted = usCurrency(price, notation);
    } else if (locale === 'es_mx' || locale === 'en_mx') {
        priceFormatted = mexCurrency(price);
    }

    return priceFormatted;
}
